// extracted by mini-css-extract-plugin
export default {"RadioText":"radio_RadioText__L3A2V","header":"radio_header__+876N"};